import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	description: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	title: {
		defaultMessage: 'Bulk action in progress',
		id: 'bulk-operations-common.submit-status.flags.in-progress-flag.title',
		description: 'Bulk edit form submission in progress flag title',
	},
	description: {
		defaultMessage: 'Stay on this page until the bulk action is finished.',
		id: 'bulk-operations-common.submit-status.flags.in-progress-flag.description',
		description: 'Bulk edit form submission in progress flag description',
	},
});
export default messages;
